import React, { useState } from 'react'
import { Box, Button, Typography } from '@mui/material';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import Textarea from '@mui/joy/Textarea';
import PlusImage from '../../../src/assets/images/notice/plusbtn.png';
import AssignCouncilorModal from '../councilor/AssignCouncilorModal';
import { addLeadNotes, assignCounselorToWebLead } from '../../api/webLeadsApi';
import { useNotification } from '../../hooks/useNotification';
import ValidationErrorText from '../common/ValidationErrorText';

const UserActions = ({ details, refetch = () => { } }) => {
    const [assignOpen, setAssignOpen] = useState(false);
    const [errors,setErrors] = useState({})
    const [note, setNotes] = useState("")
    const [saving, setSaving] = useState(false)
    const { showSuccessNotification, showErrorNotification } = useNotification()


    const handleAddNotes = () => {
        if(!note?.trim() || note?.trim()?.length<50){
            setErrors({note:"Must have more than 50 characters"})
            return
        }else{
             setErrors({})
        }
        addLeadNotes({ setSaving, payload: { _id: details._id, note } })
            .then(res => {
                refetch()
                showSuccessNotification("Successfully note added")
                setNotes("")
            }).catch(err => {
                showErrorNotification(err?.message || "Failed to add note")
            })
    };


    return (
        <>
            <Box sx={{ background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '25px', borderRadius: '16px', marginBottom: '25px' }}>
                <Box sx={{ marginBottom: '14px' }} width={"100%"}>
                    <Box>
                        <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: { xl: '24px !important', lg: '17px !important' }, marginBottom: '12px', fontWeight: '500' }}>Actions</Typography>
                    </Box>
                     {Boolean(details?.counselorName?.trim()) && <Box>
                        <Typography  sx={{ color: '#1E1E1E', fontSize: { xl: '24px !important', lg: '17px !important' }, marginBottom: '12px', }}>Counselor- {details?.counselorName}</Typography>
                    </Box>}
                   
                    {!details?.isRegistrationDone && <Button sx={{ width: "100%" }} disabled={details?.isRegistrationDone} onClick={() => setAssignOpen(true)}>
                        <Typography sx={{ width: "100%", border: '1px solid #345EFF', textAlign: 'center', padding: '14px', color: '#4B4B4B', fontWeight: '400', borderRadius: '8px' }}> <PersonAddAltIcon />  Assign Counselor</Typography>
                    </Button>}
                </Box>
                <Box>
                    <Box>
                        <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: { xl: '16px !important', lg: '13px !important' }, marginBottom: '12px', fontWeight: '500' }}>Add note</Typography>
                    </Box>
                    <Box className='textareaaction'>
                        <Textarea
                            value={note}
                            onChange={(e) => setNotes(e?.target?.value)}
                            placeholder="Type your notes here..."
                            required
                            resize
                            hel
                            sx={{ mb: 1, border: '1px solid #ddd', marginBottom: '20px', borderRadius: '8px', padding: '10px 20px', }}
                        />
                    </Box>
                     <Box sx={{ml:2}}><ValidationErrorText error={errors?.note}/></Box>
                    <Button onClick={handleAddNotes} disabled={saving} sx={{ width: "100%" }}>
                        <Typography sx={{ width: "100%", background: '#345EFF', cursor: 'pointer', borderRadius: '8px', height: '48px', display: 'flex', fontSize: '20px', justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontWeight: '400', color: '#fff' }}>
                            <img src={PlusImage} style={{ marginRight: '10px' }}></img> Add note
                        </Typography>
                    </Button>
                </Box>
            </Box>

            <AssignCouncilorModal
                refetch={refetch}
                open={assignOpen}
                onClose={() => setAssignOpen(false)}
                assignCouncilorToCall={assignCounselorToWebLead}
                info={{
                    _id: details?._id,
                    student: details?.fullName,
                    status: details?.status,
                    leadId: details?.leadId,
                }}
            />
        </>
    )
}

export default UserActions